import axios from "axios";
import { Constants } from '../utils/Constants';

export function sendVerificationEmail(email) {
	return axios.post(`${Constants.baseUrl}/email-verification/send`, {
		email
	});
}

export function verifyEmail(email, token) {
	return axios.post(`${Constants.baseUrl}/email-verification/verify`, {
		email,
		token
	});
}
